import { Link } from 'react-router-dom';
import { ShieldCheck, TrendingUp, ArrowRight } from 'lucide-react';
import { SEO, SchemaOrg } from '../components/SEO';

const TOOLS = [
  {
    slug: 'authenticate/cartier-love',
    title: 'Cartier Love Bracelet Authenticator',
    icon: ShieldCheck,
    description: 'Eight expert questions, weighted scoring, decisive verdict. Catches 95% of common counterfeits in 60 seconds.',
    tag: 'Authentication',
  },
  {
    slug: 'roi-calculator',
    title: 'Pre-Owned Jewelry ROI Calculator',
    icon: TrendingUp,
    description: "Enter a piece, the year you bought it, and what you paid. We'll calculate the annual return against our live Investment Index.",
    tag: 'Investment',
  },
];

export const ToolsIndexPage = () => (
  <div data-testid="tools-index" className="bg-[#FAF9F6]">
    <SEO
      title="Pre-Owned Luxury Jewelry Tools — Authentication Quiz, ROI Calculator"
      description="Free interactive tools for pre-owned luxury jewelry buyers. Authenticate a Cartier Love Bracelet in 60 seconds. Calculate the ROI on any tracked piece. By Jewelry Refined."
      url="/tools"
      type="website"
    />
    <SchemaOrg type="breadcrumb" data={{ items: [
      { name: 'Home', url: '/' }, { name: 'Tools', url: '/tools' }
    ]}}/>

    <section className="bg-[#111] text-white">
      <div className="container-editorial pt-20 pb-16 lg:pt-28 lg:pb-20">
        <nav className="flex items-center gap-3 text-xs tracking-[0.15em] uppercase text-white/60 mb-12">
          <Link to="/" className="hover:text-[#C69C6D] transition-colors">Home</Link>
          <span>/</span>
          <span className="text-white">Tools</span>
        </nav>
        <p className="overline text-[#C69C6D] mb-6">Free Editorial Tools</p>
        <h1 className="font-heading font-light text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight mb-8">
          The <span className="italic">Tools</span>
        </h1>
        <p className="font-heading italic text-xl lg:text-2xl text-white/85 max-w-3xl">
          Interactive decision aids built by our GIA-credentialed editors. No signup, no email gate, no sales pitch.
        </p>
      </div>
    </section>

    <section className="section-editorial">
      <div className="container-editorial">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {TOOLS.map((tool) => {
            const Icon = tool.icon;
            return (
              <Link
                key={tool.slug}
                to={`/tools/${tool.slug}`}
                data-testid={`tool-card-${tool.slug.replace(/\//g, '-')}`}
                className="group block bg-white border border-[#E5E0D8] hover:border-[#111] transition-all p-10"
              >
                <Icon className="w-10 h-10 text-[#C69C6D] mb-8" strokeWidth={1.25} />
                <p className="overline overline-gold mb-4">{tool.tag}</p>
                <h2 className="font-heading text-3xl lg:text-4xl text-[#111] font-light leading-tight mb-6 group-hover:text-[#C69C6D] transition-colors">
                  {tool.title}
                </h2>
                <p className="text-[#555] text-lg leading-relaxed mb-8">{tool.description}</p>
                <span className="inline-flex items-center gap-3 text-xs tracking-[0.2em] uppercase text-[#111] border-b border-[#111] pb-1">
                  Launch Tool <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" strokeWidth={1.5} />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  </div>
);

export default ToolsIndexPage;
